import {AfterViewChecked, AfterViewInit, Component, ElementRef, OnInit} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';

@Component(
    {
        selector:'peOS',
        template:`
            <audio id="taskbahSound" loop preload="auto">
                <source src="https://picturelements.github.io/images/win_icons/LockIt.mp3">
            </audio>
            <button id="gofull" style="display:none; position:fixed; z-index:100;">GO FULLSCREEN</button>
            <div id="desktopwrapper" class="grad backOverride">
                <div id="desktop">
                    <div id="test"></div>
                    <div id="selectbox"></div>
                    <div id="shadow"></div>
                </div>
            </div>
            <div id="context">
                <div class="contextitem">Open</div>
                <div class="contextitem">Open All</div>
                <div class="contextitem">Rename</div>
                <div class="contextitem">Pin to taskbar</div>
                <div class="contextitem">Pin</div>
                <div class="contextitem">Unpin</div>
                <div class="contextitem">Open new</div>
                <div class="contextitem">Close</div>
                <div class="contextitem">Fullscreen</div>
                <div class="contextitem">Enable context menu</div>
                <div class="contextitem">Change wallpaper</div>
                <div class="contextitem">Lock taskbar</div>
                <div class="contextitem">Lock the taskbah</div>
            </div>
            <div id="searchbar">
                <div id="searchbarbar" expanded="false">
                    <div class="sbbitem" onclick=sbbToggle(this)>
                        <div id="sbbicon" style="transform:rotate(90deg)">|||</div>
                        <div id="sbblabel"><b>SEARCH</b></div>
                    </div>
                    <div class="sbbitem" onclick=sbbHome()>
                        <div id="sbbicon" style="background-image:url(https://picturelements.github.io/images/win_icons/homehome.png)"></div>
                        <div id="sbblabel">Home</div>
                    </div>
                    <div class="sbbitem2" onclick=openSettings()>
                        <div id="sbbicon" style="background-image:url(https://picturelements.github.io/images/win_icons/cog.png)"></div>
                        <div id="sbblabel">Settings</div>
                    </div>
                    <div class="sbbitem2" onclick=togglePower() style="display:none">
                        <div id="sbbicon" style="background-image:url(https://picturelements.github.io/images/win_icons/power.png)"></div>
                        <div id="sbblabel">Power</div>
                    </div>
                </div>
                <div id="powerbar">
                    <div class="poweritem">Restart</div>
                    <div class="poweritem">Power off</div>
                </div>
                <div id="innerbar"></div>
            </div>
            <div id="clockbar" class="specColor" style="display:none;">
                <p id="clocklbl"></p>
                <table id="calendar">
                </table>
                <div class="clock specColor">
                    <div id="hour"></div>
                    <div id="minute"></div>
                    <div id="second"></div>
                    <div id="seconddot"></div>
                </div>
                <p onclick=openSettings() id="edittime">Edit time and date...</p>
            </div>
            <div id="taskbar" style="bottom: 0vw">
                <div id="home"></div>
                <input id="search" placeholder="Search in PeOS" autocomplete="off">
                <div id="infocorner">
                    <div id="time" onclick=toggleClock()>22:20<br>2016-10-07</div>
                    <div id="wifi"></div>
                    <div id="battery">
                        <!--<div id="batterylvl"></div>-->
                    </div>
                </div>
            </div>
            <div id="loadscreen"></div>
            <div [innerHTML]="styles"></div>

            <div id="settingsbuffer" style="display:none">
                <div id="settingscontainer">
                    <h>Time and Date</h>
                    <p>Time zone:</p>
                    <select id="timezone" onchange=updateTime()>
                        <option>Local</option>
                        <option>Custom offset</option>
                    </select>
                    <input id="prectz" disabled="true" placeholder="Time offset in minutes" oninput=newTime()>
                    <input id="dateset" type="date" oninput=newTime()>
                    <p id="tzlbl"></p>
                    <br>
                    <button onclick=setTime()>Set time</button>
                    <h>Filenames</h>
                    <p>Reset all filenames to their defaults. This action will take effect immediately and cannot be undone.</p>
                    <button onclick=resetNames()>Reset to default</button>
                    <h>Windows</h>
                    <p>Set the default size of opened window. Default is 40x25.<br><br><span id="winW">Window width: 40</span></p>
                    <input class="sizeslider" type="range" min="20" max="100" value="40" oninput=updateSize(0)>
                    <p id="winH">Window height: 25</p>
                    <input class="sizeslider" type="range" min="15" max="80" value="25" oninput=updateSize(1)>
                    <h id="backH">Color scheme/Backgrounds</h>
                    <p>Color scheme</p>
                    <div id="colorbar"></div>
                    <br>
                    <p>Desktop background</p>
                    <div id="backbar"></div>
                    <div id="preview" class="grad backOverride"></div>
                    <br>
                    <br>
                </div>
            </div>
            <div id="resultsbuffer" style="display:none">
                <div id="resultsbar">
                    <div id="innerresults">
                        <div id="searchmsg">Start typing to browse programs, other programs, or programs.<br><br><pt>Protip: press any arrow key to get all programs.</pt></div>
                    </div>
                </div>
            </div>
            <div id="mainbuffer" style="display:none">
                <div id="programbar">
                    <div class="pbitem">
                        <div id="pbicon"></div>
                        <div id="pbtitle"></div>
                    </div>
                </div>
                <div id="puzzlebar">
                    <div class="puzzle specColor" wide="false">Test 1</div>
                    <div class="puzzle specColor" wide="true">Test 2</div>
                    <div class="puzzle specColor" wide="false">Test 3</div>
                    <div class="puzzle specColor" wide="true">Test 4</div>
                    <div class="puzzle specColor" wide="true">Test 5</div>
                    <div class="puzzle specColor" wide="false">Test 6</div>
                    <div class="puzzle specColor" wide="true">Test 7</div>
                    <div class="puzzle specColor" wide="false">Test 8</div>
                    <div class="puzzle specColor" wide="false">Test 9</div>
                    <div class="puzzle specColor" wide="true">Test 10</div>
                    <div class="puzzle specColor" wide="false">Test 11</div>
                    <div class="puzzle specColor" style="display:none" active></div>
                </div>
            </div>

            <div id="explorerbuffer" style="display:none">
                <div class="filebar">
                    <div class="histbtn normCol svg1" active="false" [innerHTML]="svg1">

                    </div>
                    <div class="histbtn normCol svg2" active="false" [innerHTML]="svg2">

                    </div>
                    <input class="path" spellcheck="false">
                    <div class="histbtn normCol square svg3" [innerHTML]="svg3" onclick="parseGeneralURL(this,this.previousSibling.previousSibling.value)">

                    </div>
                    <div class="histbtn normCol square" [innerHTML]="svg4" onclick="moveUp(this)">

                    </div>
                    <div class="togglegroup"  onclick="toggleGT()">
                        <div class="toggleitem grid normCol" [innerHTML]="svg5">

                        </div>
                        <div class="toggleitem table normCol" [innerHTML]="svg6">

                        </div>
                    </div>
                </div>
                <div class="innercontent">
                    <div class="sidebar">
                        <div class="sidelinkwrapper"></div>
                    </div>
                    <div class="filecontent"></div>
                </div>
            </div>`,
    }
)
export class PeOsContextComponent implements AfterViewInit,AfterViewChecked,OnInit {

    constructor(
        private sanitizer: DomSanitizer,private elementRef:ElementRef) {

    }

    public styles: SafeHtml;
    public svg1: SafeHtml;
    public svg2:SafeHtml;
    public svg3:SafeHtml;
    public svg4:SafeHtml;
    public svg5:SafeHtml;
    public svg6:SafeHtml;
    ngAfterViewChecked(): void {
    }

    ngOnInit() {
        this.styles = this.sanitizer.bypassSecurityTrustHtml(`
      <style id="specCols">
      </style>
    `);

      this.svg1 = this.sanitizer.bypassSecurityTrustHtml(`<svg width="90" height="90" viewBox="0 0 90 90">
                            <path d="M20 45 L55 20 L55 70"></path>
                        </svg>`);

      this.svg2 = this.sanitizer.bypassSecurityTrustHtml(`<svg width="90" height="90" viewBox="0 0 90 90">
        <path d="M30 20 L65 45 L30 70"></path>
            </svg>`);

      this.svg3 = this.sanitizer.bypassSecurityTrustHtml(`<svg width="90" height="90" viewBox="0 0 90 90">
                            <path d="M25 20 L65 45 L25 70"></path>
                        </svg>`);

      this.svg4 = this.sanitizer.bypassSecurityTrustHtml(`<svg width="90" height="90" viewBox="0 0 90 90">
                            <path d="M45 20 L65 50 L50 50 L50 70 L40 70 L40 50 L25 50"></path>
                        </svg>`);


      this.svg5 = this.sanitizer.bypassSecurityTrustHtml(`<svg width="90" height="90" viewBox="0 0 90 90">
                                <rect x="15" y="15" width="25" height="25"></rect>
                                <rect x="50" y="15" width="25" height="25"></rect>
                                <rect x="15" y="50" width="25" height="25"></rect>
                                <rect x="50" y="50" width="25" height="25"></rect>
                            </svg>`);

      this.svg6 = this.sanitizer.bypassSecurityTrustHtml(`<svg width="90" height="90" viewBox="0 0 90 90">
                                <rect x="15" y="25" width="60" height="5"></rect>
                                <rect x="15" y="42" width="60" height="5"></rect>
                                <rect x="15" y="60" width="60" height="5"></rect>
                            </svg>`);

    }
    ngAfterViewInit() {
        const s = document.createElement('script');
        s.type = 'text/javascript';
        s.src = '../assets/script/peOS.js';

        const s2 = document.createElement('script');
        s2.type = 'text/javascript';
        s2.src = '../assets/script/testDropper.js';
        this.elementRef.nativeElement.appendChild(s2);
        this.elementRef.nativeElement.appendChild(s);
    }

}
